import React, { Component } from 'react';
import { UniGrid } from './UniGrid';
import { apiGet, toLowerKeys } from '../GanjiTools';
import { Button } from 'devextreme-react';
import MinimalButton from './MinimalButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


class UniMetaGrid extends Component {

    state = {
        rows: [],
        columns: []
    }

    uniMetaColumns = this.props.dynaLoad === false ? [
        { name: 'summary', visible: false },
        { name: 'id', visible: false },
        { name: 'tablename', visible: false },
        { name: 'columnname', caption: 'نام ستون', readOnly: true },
        { name: 'columnorder', format: 'number', caption: 'ترتیب', keyFilter: 'pnum' },
        { name: 'isreadonly', format: 'bool', caption: 'فقط خواندنی' },
        { name: 'isparent', format: 'bool', caption: 'ریشه' },
        { name: 'isgroup', format: 'bool', caption: 'گروه' },
        { name: 'ishidden', format: 'bool', caption: 'پنهان' },
        { name: 'isimage', format: 'bool', caption: 'تصویر' },
        { name: 'datatypeformat', caption: 'فرمت' },
        { name: 'filtertype', caption: 'نوع فیلتر' },
        { name: 'caption_fa', caption: 'عنوان فارسی' },
        { name: 'caption_en', caption: 'عنوان انگلیسی' },
        { name: 'caption_ar', caption: 'عنوان عربی' },
        { name: 'attrib', caption: 'خصوصیات' },
        { name: 'columnwidth', format: 'number', caption: 'عرض' },
    ] : [ // must be updated: --------------------------------------------------
        { name: 'summary', visible: false },
        { name: 'id', visible: false },
        { name: 'fk_gridoption', visible: false },
        { name: 'name', caption: 'نام ستون', readOnly: true },
        { name: 'columnorder', format: 'number', caption: 'ترتیب', keyFilter: 'pnum' },
        { name: 'isreadonly', format: 'bool', caption: 'فقط خواندنی' },
        { name: 'isparent', format: 'bool', caption: 'ریشه' },
        { name: 'isgroup', format: 'bool', caption: 'گروه' },
        { name: 'ishidden', format: 'bool', caption: 'پنهان' },
        { name: 'isimage', format: 'bool', caption: 'تصویر' },
        { name: 'datatypeformat', caption: 'فرمت' },
        { name: 'filtertype', caption: 'نوع فیلتر' },
        { name: 'caption_fa', caption: 'عنوان فارسی' },
        { name: 'caption_en', caption: 'عنوان انگلیسی' },
        { name: 'caption_ar', caption: 'عنوان عربی' },
        { name: 'attrib', caption: 'خصوصیات' },
        { name: 'columnwidth', format: 'number', caption: 'عرض' },
    ];

    componentDidMount() {
        if (this.props.sourceTable?.length > 0)
            if (this.props.dynaLoad !== false)
                apiGet(`/api/dyna/cols/${this.props.sourceTable}`,
                    resp => { this.setState({ rows: toLowerKeys(resp.list) }) },
                    err => console.log('Could not fetch MetaUniGrid for table ', this.props.sourceTable, ' | error= ', err)
                );
            else
                apiGet(`/api/uni/metaGrid/${this.props.sourceTable}`,
                    resp => { this.setState({ rows: toLowerKeys(resp.rows) }) },
                    err => console.log('Could not fetch MetaUniGrid for table ', this.props.sourceTable, ' | error= ', err)
                );
        else if (this.props.sourceSid?.length > 0)
            apiGet(`/api/uni/metaUrlGrid/${this.props.sourceSid}/${JSON.stringify(this.props.sourceColNames)}`,
                resp => { this.setState({ rows: toLowerKeys(resp.rows) }) },
                err => console.log('Could not fetch MetaUniGrid for sid ', this.props.sourceSid, ' | error= ', err)
            );
    }

    render() { // macan@2023@
        console.log('meta rows=', this.state.rows);
        console.log('meta cols=', this.state.columns);
        let saveToTable = this.props.dynaLoad !== false ? 'UniGridColOption' : 'tbl_UniGridSetting';

        if (this.props.dynaLoad !== false)
            return (
                <>
                    <div style={{ height: '1rem' }}>&nbsp;</div>
                    <UniGrid key={this.state.rows?.length} rows={this.state.rows} noMetaGrid={true}
                        columns={this.uniMetaColumns} //modifyFields={this.uniMetaColumns}
                        onSaving={e => console.log('onSaving ', e)} saveToTable={saveToTable}
                        title={this.props.title?.length > 0 ? `اطلاعات ستونهای "${this.props.title}"` : 'اطلاعات ستونها'}
                        onSaved={() => this.props.onSaved(this.state.rows)}
                        allowDeleting={false}
                        allowAdding={this.props.sourceSid?.length > 0}
                        allowEditing={true} //////////////////
                        editingMode='row' putTitleBoxInToolbar
                        putItemsBeforeTitle={
                            <MinimalButton onClick={this.props.onCloseMe} style={{ marginLeft: '0.5rem' }}>
                                <FontAwesomeIcon icon='square-xmark' fontSize='25px' />
                            </MinimalButton>
                        }
                    />
                </>

            );

        return (
            <>
                <div style={{ height: '1rem' }}>&nbsp;</div>
                <UniGrid key={this.state.rows?.length} rows={this.state.rows} noMetaGrid={true}
                    columns={this.uniMetaColumns} //modifyFields={this.uniMetaColumns}
                    onSaving={e => console.log('onSaving ', e)} //saveToTable={saveToTable}
                    title={this.props.title?.length > 0 ? `اطلاعات ستونهای "${this.props.title}"` : 'اطلاعات ستونها'}
                    onSaved={() => this.props.onSaved(this.state.rows)}
                    allowDeleting={false}
                    allowAdding={this.props.sourceSid?.length > 0}
                    allowEditing={true} //////////////////
                    editingMode='row' putTitleBoxInToolbar
                    putItemsBeforeTitle={
                        <MinimalButton onClick={this.props.onCloseMe} style={{ marginLeft: '0.5rem' }}>
                            <FontAwesomeIcon icon='square-xmark' fontSize='25px' />
                        </MinimalButton>
                    }
                />
            </>
        );
    }
}

export default UniMetaGrid;